import { ElementRef, Injectable } from '@angular/core';
import * as cytoscape from 'cytoscape';

@Injectable({
  providedIn: 'root',
})
export class NgFlowDesignerService {
  private currentCy?: cytoscape.Core;
  public hostRemoverElement: ElementRef;

  public removeConnectedEdges(nodeId: string) {
    this.cy()
      .getElementById(nodeId)
      .connectedEdges()
      .forEach(edge => {
        edge.connectedNodes().forEach(output => {
          if (output.data('isOutput')) {
            edge.remove();
            output.data('directive').targetChange.emit(undefined);
          }
        });
      });
  }

  forceRender() {
    // @ts-ignore
    this.cy()._private.renderer.render();
  }

  setCurrentCy(cy: cytoscape.Core | undefined) {
    this.currentCy = cy;
  }

  private cy(): cytoscape.Core {
    if (!this.currentCy) {
      throw new Error(`No cytoscape instance set`);
    }
    return this.currentCy;
  }
}
